module.exports = __webpack_public_path__ + "assets/img/ru-487cc1cb.png";